import { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { CreateChannelDialog } from './CreateChannelDialog';
import { Plus } from 'lucide-react';

interface Channel {
  id: string;
  name: string;
}

interface ChannelSelectorProps {
  channels: Channel[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export const ChannelSelector = ({
  channels,
  value,
  onValueChange,
  placeholder = 'Choose a channel',
  disabled = false,
  className,
}: ChannelSelectorProps) => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const CREATE_NEW_VALUE = '__CREATE_NEW__';

  const handleValueChange = (newValue: string) => {
    if (newValue === CREATE_NEW_VALUE) {
      setCreateDialogOpen(true);
    } else {
      onValueChange(newValue);
    }
  };

  const handleChannelCreated = (channelId: string, channelName: string) => {
    onValueChange(channelId);
  };

  return (
    <>
      <Select value={value} onValueChange={handleValueChange} disabled={disabled}>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {channels.map((channel) => (
            <SelectItem key={channel.id} value={channel.id}>
              {channel.name}
            </SelectItem>
          ))}
          <SelectItem 
            value={CREATE_NEW_VALUE}
            className="text-primary font-medium border-t mt-1 pt-2"
          >
            <div className="flex items-center gap-2">
              <Plus className="h-4 w-4" />
              <span>Create new channel</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>

      <CreateChannelDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onChannelCreated={handleChannelCreated}
      />
    </>
  );
};
